import '@babel/polyfill';
import React, { useEffect, useState, Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import ReactDOM from 'react-dom';
// import './includes/custom/css/index.css';
import { Provider } from 'react-redux';
import configureStore from '@AppRedux/store';
import { rootRoutes } from './app.modules.js';
import {
    BrowserRouter,
    Switch,
} from 'react-router-dom';
import PrivateRoute from './views/components/PrivateRoute';
import CustomRoute from './views/components/CustomRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import './includes/font-awesome/5.12.1/css/all.min.css';
import IdleTimerContainer from '@BaseComponents/Common/IdleTimer/IdleTimerContainer'
// Custom CSS
// import './includes/custom/css/styles.css';
// import './includes/custom/css/custom-style.css';
// import './includes/custom/css/custom-bootstrap.css';
// import './includes/custom/css/asi.css';
import './includes/custom/ais.app.css';
import './includes/custom/css/select-search.css';
import './includes/custom/css/custom-bootstrap.css';

import MainHeader from '@BaseComponents/MainHeader';
import MainFooter from '@BaseComponents/MainFooter';
import Sidenav from '@BaseComponents/Sidenav';
import Loader from '@BaseComponents/Loader';
import useToggle from '@Utils/hooks/useToggle';
import $ from 'jquery';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-datetime/css/react-datetime.css';
import OkModal from '@BaseComponents/Common/OkModal';
import ConfirmModal from '@BaseComponents/Common/ConfirmModal';

const LoadingScreen = () => {
    return (
        <div id='loading-bar-container'>
            <div id='loading-bar'>
                <div className='sk-folding-cube' style={{ width: '100%' }}>
                    <div className='sk-cube1 sk-cube'></div>
                    <div className='sk-cube2 sk-cube'></div>
                    <div className='sk-cube4 sk-cube'></div>
                    <div className='sk-cube3 sk-cube'></div>
                </div>
            </div>
        </div>
    );
}

const RootWrapper = () => {
    return (
        <Provider store={configureStore()}>
            <Root />
        </Provider>
    );
}

const Confirm = (props) => {
    const allowTransition = () => {
        props.setConfirm(false);
        props.confirmCallback(true);
    }

    const blockTransition = () => {
        props.setConfirm(false);
        props.confirmCallback(false);
    }

    return (
        <ConfirmModal
            show
            title='Confirm Action'
            message={props.message}
            onClose={blockTransition}
            onConfirm={allowTransition}
        />
    );
}

const Alert = (props) => {
    const blockTransition = () => {
        props.setConfirm(false);
        if (typeof props.alertCallback === 'function')
            props.alertCallback();
    }

    return (
        <OkModal
            show
            title={props.title}
            message={props.message}
            onHide={blockTransition}
        />
    );
}

const Root = (props) => {
    const dispatch = useDispatch()
    const xhrError = useSelector(({ xhrError: xhr }) => xhr)
    const isPageLoading = useSelector(({ loader }) => loader.loading)
    const [showSidebar, toggleSidebar] = useToggle(false);
    const [isLoading, setLoading] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [confirmCallback, setConfirmCallback] = useState(null);
    const [confirmMessage, setConfirmMessage] = useState(`Changes won't be saved. Are you sure you want to proceed?`);

    // GLOBAL ALERT
    const [showAlert, toggleAlert] = useState(false);
    const [alertCallback, setAlertCallback] = useState(null);
    const [alertTitle, setAlertTitle] = useState('Warning');
    const [alertMessage, setAlertMessage] = useState('There was an error processing your request.');

    useEffect(() => {
        if (xhrError.error) {
            setAlert(xhrError.title,
                xhrError.message,
                () => {
                    dispatch({ type: 'HIDE_XHR_ERROR', payload: '' })
                })
        }
    }, [xhrError.error])

    useEffect(() => {
        if (showSidebar) {
            document.body.classList.add('open-nav');
        } else {
            document.body.classList.remove('open-nav');
        }
    }, [showSidebar]);

    useEffect(() => {
        let $loader = $('#loading-bar-container');
        if (isLoading) {
            $loader.html(`<div id='loading-bar'>
                    <div class='sk-folding-cube' style="width: 100%">
                        <div class='sk-cube1 sk-cube'></div>
                        <div class='sk-cube2 sk-cube'></div>
                        <div class='sk-cube4 sk-cube'></div>
                        <div class='sk-cube3 sk-cube'></div>
                    </div>
                </div>`);
        } else {
            $loader.empty();
        }
    }, [isLoading])

    useEffect(() => {
        let $loader = $('#loading-bar-container');
        if (isPageLoading) {
            $loader.html(`<div id='loading-bar'>
                    <div class='sk-folding-cube' style="width: 100%">
                        <div class='sk-cube1 sk-cube'></div>
                        <div class='sk-cube2 sk-cube'></div>
                        <div class='sk-cube4 sk-cube'></div>
                        <div class='sk-cube3 sk-cube'></div>
                    </div>
                </div>`);
        } else {
            $loader.empty();
        }
    }, [isPageLoading])

    const getConfirmation = (message, callback) => {
        if (message && message.trim().length !== 0) {
            setConfirmMessage(message);
        }
        setConfirmCallback(() => callback);
        setConfirm(true);
    }

    const setAlert = (title, message, callback) => {
        if (title && title.trim().length !== 0) {
            setAlertTitle(title);
        }
        if (message && message.trim().length !== 0) {
            setAlertMessage(message);
        }
        setAlertCallback(() => callback);
        toggleAlert(true);
    }

    return (
        <>
            <BrowserRouter initialEntries={[props.currentPath]} getUserConfirmation={getConfirmation}>
                <MainHeader
                    toggleSidebar={toggleSidebar}
                />
                <div className='wrapper'>
                    <Sidenav/>
                    <Loader/>
                    <div id='main'>
                        <div id='content'>
                            <Suspense fallback={<LoadingScreen/>}>
                                <Switch>
                                    {rootRoutes.map((route, i) =>
                                        route.public ?
                                            <CustomRoute
                                                key={i}
                                                exact
                                                setLoading={setLoading}
                                                toggleAlert={toggleAlert}
                                                setAlert={setAlert}
                                                {...route}
                                            />
                                            :
                                            <PrivateRoute
                                                key={i}
                                                setLoading={setLoading}
                                                toggleAlert={toggleAlert}
                                                setAlert={setAlert}
                                                {...route}
                                            />)
                                    }
                                </Switch>

                                {confirm && (
                                    <Confirm
                                        message={confirmMessage}
                                        confirmCallback={confirmCallback}
                                        setConfirm={setConfirm}
                                    />
                                )}

                                {showAlert && (
                                    <Alert
                                        title={alertTitle}
                                        message={alertMessage}
                                        alertCallback={alertCallback}
                                        setConfirm={toggleAlert}
                                    />
                                )}
                            </Suspense>
                        </div>
                    </div>
                </div>
            </BrowserRouter>
            <MainFooter/>
            <IdleTimerContainer />
        </>
    )
}

ReactDOM.render(
    <RootWrapper />,
    document.getElementById('root')
);
